/* 
Main es el encargado de ver si esta logueado para mostrar login o home
 */

import React from "react";

//REDUX
import { useSelector } from "react-redux";

//PAGES
import Home from "../pages/Home";
import Login from "../pages/loginAndRegister/Login";

export default function Main({ history, match }) {
  const { mail } = match.params;

  const user = useSelector(state => state.user);

  return (
    <div>
      {!user || user.isLogged ?
        <Home />
        : <Login history={history} mail={mail} />}
    </div>
  );
}

